// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditModule_containers {
  overflow: hidden;
  height: 100vh;
}
.EditModule_containers .AddEditModule_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.EditModule_containers .sidebar {
  width: 20%;
  background: #dde7f5;
}
.EditModule_containers .AddEditModulecontent {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 83vh;
}
.EditModule_containers .input-wrapper {
  position: relative;
  width: 100%;
}
.EditModule_containers label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.EditModule_containers .select_label {
  position: absolute;
  top: -7px;
  left: 9px;
  font-size: 10px;
}
.EditModule_containers .AddEditModule_panel .panel-all {
  display: flex;
  width: 95%;
  margin: 1rem;
  font-family: Nunito;
  font-weight: 600;
  font-size: 20px;
  color: rgb(16, 19, 46);
}
.EditModule_containers .AddEditModule_panel .panel-all .AddEditModule_Close {
  width: 15%;
  height: 40px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #FFFFFF;
  border: none;
  margin-left: 64%;
}
.EditModule_containers .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #C0C8DA;
}
.EditModule_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.EditModule_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.EditModule_containers .hero-section {
  width: 100%;
  border-radius: 6px;
  background: #ffffff;
}
.EditModule_containers .hero-section .title-input {
  margin-left: 0.6rem;
  width: 99%;
  display: flex;
}
.EditModule_containers .hero-section .text-field {
  border: 1px solid gray;
  border-radius: 0px;
  position: relative;
  width: 92%;
  margin: 10px;
  line-height: 6ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132E;
  padding: 0rem 0.5rem;
  height: 2.5rem;
}
.EditModule_containers .hero-section .input-wrapper {
  position: relative;
}
.EditModule_containers .hero-section .panel-text {
  font-size: 14px;
  font-family: "Nunito";
  font-weight: 400;
  color: rgb(12, 54, 136);
  height: 19px;
  margin: 10px;
  padding: 0rem 0.6rem;
}
.EditModule_containers .hero-section .modulePanel_checkbox {
  display: flex;
  justify-content: space-between;
  width: 96%;
  border: 1px solid rgb(153, 151, 151);
  border: 1px solid #c1c6d0;
  border-radius: 4px 4px 0px 0px;
  border: 1px solid #c1c6d0;
  margin: 0rem 1rem 0rem 1rem;
  padding: 0.6rem;
  position: relative;
  background: rgb(242, 244, 248);
  gap: 0.5rem;
}
.EditModule_containers .hero-section .button_search {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 40%;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}
.EditModule_containers .hero-section .checkbox_contain {
  width: 50%;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.EditModule_containers .hero-section .checkbox_label {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgb(16, 19, 46);
}
.EditModule_containers .hero-section .checkbox_labelactive {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgb(12, 54, 136);
}
.EditModule_containers .hero-section .checkbox_container {
  display: flex;
  width: 20%;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}
.EditModule_containers .hero-section .checkbox_containerTutorial {
  display: flex;
  width: 18%;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}
.EditModule_containers .hero-section .checkbox_containerTrouble {
  display: flex;
  width: 18%;
  justify-content: center;
  align-items: center;
}
.EditModule_containers .hero-section .input_checkbox {
  width: 18px;
  height: 18px;
  margin: 0.5rem;
  border-radius: 1rem;
  background: rgb(0, 0, 0);
}
.EditModule_containers .hero-section .input_checkbox:checked {
  background: rgb(12, 54, 136) !important;
  color: white;
}
.EditModule_containers .hero-section .model_div {
  width: 100%;
}
.EditModule_containers .hero-section .search-box {
  display: flex;
  width: 50%;
  justify-content: end;
}
.EditModule_containers .hero-section .search-input {
  font-size: 1rem;
  border: none;
  border: 1px solid rgb(163, 174, 196);
  height: 32px;
  width: 60%;
  border-radius: 4px 0px 0px 4px;
  padding: 0rem 0.5rem;
}
.EditModule_containers .hero-section .search-icon {
  height: 32px;
  background: rgb(32, 87, 194);
  display: flex;
  justify-content: center;
  align-items: center;
}
.EditModule_containers .hero-section .search-icon button {
  background: rgb(32, 87, 194);
  color: white;
}
.EditModule_containers .table-content {
  width: 97.6%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 50vh;
}
.EditModule_containers .table-content .tabledata {
  display: flex;
  width: 98.5%;
  margin-left: 1rem;
  overflow-y: scroll;
}
.EditModule_containers .table-content .table {
  border-collapse: collapse;
  width: 100%;
  background: #ffffff;
  border: 0.5px solid #999797;
}
.EditModule_containers .table-content .video_image {
  padding: 1rem !important;
}
.EditModule_containers .table-content .pdf_image {
  padding: 0.8rem !important;
}
.EditModule_containers .table-content .tablesth {
  color: white;
  text-align: left;
  padding: 14px 12px;
  background-color: #f5f5f5;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  background: #0c3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px -2px 0px 0px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.EditModule_containers .table-content .tabletd {
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  font-family: "Nunito";
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
  vertical-align: middle;
  width: 20%;
  white-space: break-spaces !important;
  word-break: break-all;
}
.EditModule_containers .table-content .tabletd_view {
  text-align: left;
  padding: 22px 5px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  border-top: 0.5px solid #999797;
  cursor: pointer;
}
.EditModule_containers .table-content .edit-Module-pagination {
  position: sticky;
  bottom: 0;
}
.EditModule_containers .table-content .pagination {
  background-color: rgb(229, 240, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
  gap: 1rem;
  height: 3rem;
  margin: 0rem 0rem 0rem 1rem;
}
.EditModule_containers .AddEditmodel_panel .panel-all {
  display: flex;
  width: 95%;
  margin: 1rem;
  font-family: Nunito;
  font-weight: 600;
  font-size: 20px;
  color: rgb(16, 19, 46);
}
.EditModule_containers .AddEditmodel_panel .panel-all .AddEditmodel_create {
  width: 15%;
  height: 40px;
  background: #0C3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #FFFFFF;
  border: none;
}
.EditModule_containers .AddEditmodel_panel .panel-all .AddEditmodel_create:disabled {
  background: #5a77b0;
}
.EditModule_containers .add-modules-titles {
  position: absolute;
  top: 32%;
  left: 80%;
  font-size: 14px;
}

.module-form-select {
  width: 13rem;
  background-color: white;
}

.module-form-select fieldset {
  border: 1px solid #a3aec4;
  border-radius: 6px;
}

.module-select {
  height: 32px;
  width: 100% !important;
}

.module_input {
  min-width: 80%;
}

::-webkit-scrollbar {
  width: 0.875em;
}

::-webkit-scrollbar-thumb {
  background: rgb(163, 174, 196);
  border-radius: 0em;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgb(163, 174, 196);
}

.content-titless {
  position: absolute;
  left: 82%;
  z-index: 4;
  top: 1.2rem;
  font-size: 13px;
}

@media screen and (max-width: 480px) {
  .AddEditModule_container {
    display: flex;
    flex-direction: column;
  }
  .AddEditModulecontent {
    width: 100% !important;
    margin: auto;
  }
  .search-input {
    width: 90px !important;
  }
  .EditModule_containers .hero-section .modulePanel_checkbox {
    display: flex;
    justify-content: space-around !important;
  }
  .EditModule_containers .hero-section .title-input {
    display: flex;
    flex-direction: column;
    width: 70%;
  }
  .EditModule_containers .AddEditModule_panel .panel-all .AddEditModule_Close {
    margin-left: 50% !important;
    width: fit-content;
  }
  .EditModule_containers .hero-section .checkbox_contain {
    flex-direction: column;
    gap: 0rem;
  }
  .module-form-select {
    width: 100% !important;
  }
  .EditModule_containers .hero-section .checkbox_contain.checkbox_contain {
    gap: 1rem !important;
  }
}
@media screen and (max-width: 768px) {
  .EditModule_containers .AddEditModule_container {
    flex-direction: column;
  }
  .EditModule_containers .AddEditModulecontent {
    width: 100% !important;
    height: 50vh;
  }
  .AddEditmodel_create {
    width: fit-content !important;
  }
  .EditModule_containers .hero-section .search-input {
    width: 100% !important;
  }
  .EditModule_containers .hero-section .modulePanel_checkbox {
    flex-wrap: wrap;
  }
  .EditModule_containers .hero-section .checkbox_contain {
    justify-content: flex-start;
  }
  .add-modules-titles {
    top: 50% !important;
    font-size: 12px !important;
  }
  .content-titless {
    top: 50% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/EditModule/editmodule.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAGI;EACI,UAAA;EACA,mBAAA;AADR;AAII;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAFR;AAMI;EACI,kBAAA;EACA,WAAA;AAJR;AAOI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALR;AAOI;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;AALR;AASQ;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAPZ;AASY;EACI,UAAA;EACA,YAAA;EACA,mEAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAPhB;AAaI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAXR;AAcI;EACI,mBAAA;AAZR;AAeI;EAEI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAdR;AAiBI;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;AAfR;AAiBQ;EACI,mBAAA;EACA,UAAA;EACA,aAAA;AAfZ;AAkBQ;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,cAAA;AAhBZ;AAmBQ;EACI,kBAAA;AAjBZ;AAoBQ;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;AAlBZ;AAsBQ;EACI,aAAA;EACA,8BAAA;EACA,UAAA;EACA,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;AApBZ;AAwBQ;EACI,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAtBZ;AAyBQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAvBZ;AA0BQ;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAxBZ;AA0BQ;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAxBZ;AA0BQ;EACI,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAxBZ;AA2BQ;EACI,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAzBZ;AA4BQ;EACI,aAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AA1BZ;AA6BQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;AA3BZ;AA8BQ;EACI,uCAAA;EACA,YAAA;AA5BZ;AA+BQ;EACI,WAAA;AA7BZ;AAgCQ;EACI,aAAA;EACA,UAAA;EACA,oBAAA;AA9BZ;AAiCQ;EACI,eAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;EACA,8BAAA;EACA,oBAAA;AA/BZ;AAkCQ;EACI,YAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhCZ;AAmCQ;EACI,4BAAA;EACA,YAAA;AAjCZ;AAsCI;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AApCR;AAuCQ;EACI,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AArCZ;AAwCQ;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AAtCZ;AAwCO;EACC,wBAAA;AAtCR;AAwCO;EACC,0BAAA;AAtCR;AAwCQ;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAtCZ;AAyCQ;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,sBAAA;EACA,UAAA;EACA,oCAAA;EACA,qBAAA;AAvCZ;AA0CQ;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;AAxCZ;AA2CQ;EACI,gBAAA;EACA,SAAA;AAzCZ;AA2CQ;EACI,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;AAzCZ;AA8CQ;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AA5CZ;AA8CY;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA5ChB;AA+CY;EACI,mBAAA;AA7ChB;AAkDI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AAhDR;;AAoDA;EACI,YAAA;EACA,uBAAA;AAjDJ;;AAmDA;EACI,yBAAA;EACA,kBAAA;AAhDJ;;AAkDA;EACI,YAAA;EACA,sBAAA;AA/CJ;;AAiDA;EACI,cAAA;AA9CJ;;AAiDA;EACI,cAAA;AA9CJ;;AAiDA;EACI,8BAAA;EACA,kBAAA;AA9CJ;;AAiDA;EACI,oCAAA;AA9CJ;;AAgDA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;AA7CJ;;AA+CA;EACI;IACI,aAAA;IACA,sBAAA;EA5CN;EA8CE;IACI,sBAAA;IACA,YAAA;EA5CN;EA8CE;IACI,sBAAA;EA5CN;EA+CE;IACI,aAAA;IACA,wCAAA;EA7CN;EAgDE;IACI,aAAA;IACA,sBAAA;IACA,UAAA;EA9CN;EAgDE;IACI,2BAAA;IACA,kBAAA;EA9CN;EAgDE;IACI,sBAAA;IACA,SAAA;EA9CN;EAgDE;IACI,sBAAA;EA9CN;EAgDE;IACI,oBAAA;EA9CN;AACF;AAgDA;EACI;IACI,sBAAA;EA9CN;EAgDE;IACI,sBAAA;IACA,YAAA;EA9CN;EAgDE;IACI,6BAAA;EA9CN;EAgDE;IACI,sBAAA;EA9CN;EAgDE;IACI,eAAA;EA9CN;EAgDE;IACI,2BAAA;EA9CN;EAgDE;IACI,mBAAA;IACA,0BAAA;EA9CN;EAgDE;IACI,mBAAA;EA9CN;AACF","sourcesContent":[".EditModule_containers {\n    overflow: hidden;\n    height: 100vh;\n\n    .AddEditModule_container {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n\n    .sidebar {\n        width: 20%;\n        background: #dde7f5;\n    }\n\n    .AddEditModulecontent {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 83vh;\n\n    }\n\n    .input-wrapper {\n        position: relative;\n        width: 100%;\n    }\n\n    label {\n        position: absolute;\n        top: 0.2ex;\n        z-index: 1;\n        left: 2em;\n        background-color: white;\n        padding: 0 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #0c3688;\n    }\n    .select_label{\n        position: absolute;\n        top: -7px;\n        left: 9px;\n        font-size: 10px;\n    }\n\n    .AddEditModule_panel {\n        .panel-all {\n            display: flex;\n            width: 95%;\n            margin: 1rem;\n            font-family: Nunito;\n            font-weight: 600;\n            font-size: 20px;\n            color: rgba(16, 19, 46, 1);\n\n            .AddEditModule_Close {\n                width: 15%;\n                height: 40px;\n                background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 1rem;\n                color: #FFFFFF;\n                border: none;\n                margin-left: 64%;\n\n            }\n        }\n    }\n\n    .header_border {\n        background: #C0C8DA;\n        height: 2.4rem;\n        border: 1px solid #C0C8DA;\n    }\n\n    .header_border>img {\n        margin: 0.9rem 1rem;\n    }\n\n    .header_border>span {\n\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        display: flex;\n        align-items: center;\n        letter-spacing: -0.28px;\n        margin: 0.7rem 1rem;\n    }\n\n    .hero-section {\n        width: 100%;\n        border-radius: 6px;\n        background: #ffffff;\n\n        .title-input {\n            margin-left: 0.6rem;\n            width: 99%;\n            display: flex;\n        }\n\n        .text-field {\n            border: 1px solid gray;\n            border-radius: 0px;\n            position: relative;\n            width: 92%;\n            margin: 10px;\n            line-height: 6ex;\n            font-family: \"Nunito\";\n            font-style: normal;\n            font-weight: 600;\n            font-size: 16px;\n            color: #10132E;\n            padding: 0rem 0.5rem;\n            height: 2.5rem;\n        }\n\n        .input-wrapper {\n            position: relative;\n        }\n\n        .panel-text {\n            font-size: 14px;\n            font-family: \"Nunito\";\n            font-weight: 400;\n            color: rgb(12, 54, 136);\n            height: 19px;\n            margin: 10px;\n            padding: 0rem 0.6rem;\n\n        }\n\n        .modulePanel_checkbox {\n            display: flex;\n            justify-content: space-between;\n            width: 96%;\n            border: 1px solid rgba(153, 151, 151, 1);\n            border: 1px solid #c1c6d0;\n            border-radius: 4px 4px 0px 0px;\n            border: 1px solid #c1c6d0;\n            margin: 0rem 1rem 0rem 1rem;\n            padding: 0.6rem;\n            position: relative;\n            background: rgba(242, 244, 248, 1);\n            gap: 0.5rem;\n        }\n\n\n        .button_search {\n            background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n            box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n            border-radius: 5px;\n            font-family: \"Nunito\";\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            display: flex;\n            align-items: center;\n            color: #ffffff;\n            width: 40%;\n            height: 2.5rem;\n            text-align: center;\n            justify-content: center;\n            border: none;\n            margin: 0.6rem 1rem;\n        }\n\n        .checkbox_contain {\n            width: 50%;\n            display: flex;\n            align-items: center;\n            gap: 1rem;\n        }\n\n        .checkbox_label {\n            font-family: \"Nunito\";\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            color: rgba(16, 19, 46, 1);\n        }\n        .checkbox_labelactive {\n            font-family: \"Nunito\";\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            color: rgba(12, 54, 136, 1);\n        }\n        .checkbox_container {\n            display: flex;\n            width: 20%;\n            justify-content: center;\n            align-items: center;\n            margin-right: 20px;\n        }\n\n        .checkbox_containerTutorial {\n            display: flex;\n            width: 18%;\n            justify-content: center;\n            align-items: center;\n            margin-right: 20px;\n        }\n\n        .checkbox_containerTrouble {\n            display: flex;\n            width: 18%;\n            justify-content: center;\n            align-items: center;\n        }\n\n        .input_checkbox {\n            width: 18px;\n            height: 18px;\n            margin: 0.5rem;\n            border-radius: 1rem;\n            background: rgba(0, 0, 0, 1);\n        }\n\n        .input_checkbox:checked {\n            background: rgba(12, 54, 136, 1) !important;\n            color: white;\n        }\n\n        .model_div {\n            width: 100%;\n        }\n\n        .search-box {\n            display: flex;\n            width: 50%;\n            justify-content: end;\n        }\n\n        .search-input {\n            font-size: 1rem;\n            border: none;\n            border: 1px solid rgba(163, 174, 196, 1);\n            height: 32px;\n            width: 60%;\n            border-radius: 4px 0px 0px 4px;\n            padding: 0rem 0.5rem;\n        }\n\n        .search-icon {\n            height: 32px;\n            background: rgba(32, 87, 194, 1);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n\n        .search-icon button{\n            background: rgba(32, 87, 194, 1);\n            color: white;\n        }\n\n    }\n\n    .table-content {\n        width: 97.6%;\n        background: #ffffff;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 50vh;\n\n\n        .tabledata {\n            display: flex;\n            width: 98.5%;\n            margin-left: 1rem;\n            overflow-y: scroll;\n        }\n       \n        .table {\n            border-collapse: collapse;\n            width: 100%;\n            background: #ffffff;\n            border: 0.5px solid #999797;\n        }\n       .video_image{\n        padding: 1rem !important;\n       }\n       .pdf_image{\n        padding: 0.8rem !important;\n       }\n        .tablesth {\n            color: white;\n            text-align: left;\n            padding: 14px 12px;\n            background-color: #f5f5f5;\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            background: #0c3688;\n            box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n            border-radius: 5px -2px 0px 0px;\n            font-family: \"Nunito\";\n            font-style: normal;\n            font-weight: 700;\n            font-size: 16px;\n            color: #ffffff;\n        }\n\n        .tabletd {\n            padding: 22px 5px;\n            font-style: normal;\n            font-weight: 400;\n            text-align: left;\n            font-family: \"Nunito\";\n            font-size: 14px;\n            color: #070707;\n            border-top: 0.5px solid #999797;\n            vertical-align: middle;\n            width: 20%;\n            white-space: break-spaces !important;\n            word-break: break-all;\n        }\n\n        .tabletd_view {\n            text-align: left;\n            padding: 22px 5px;\n            text-align: left;\n            padding: 14px;\n            font-family: \"Nunito\";\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            text-decoration-line: underline;\n            color: #0c3688;\n            border-top: 0.5px solid #999797;\n            cursor: pointer;\n\n        }\n        .edit-Module-pagination{\n            position: sticky;\n            bottom: 0;\n        }\n        .pagination {\n            background-color: rgb(229, 240, 255);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            padding: 0.5rem 0;\n            gap: 1rem;\n            height: 3rem;\n            margin: 0rem 0rem 0rem 1rem;\n          }\n    }\n\n    .AddEditmodel_panel {\n        .panel-all {\n            display: flex;\n            width: 95%;\n            margin: 1rem;\n            font-family: Nunito;\n            font-weight: 600;\n            font-size: 20px;\n            color: rgba(16, 19, 46, 1);\n\n            .AddEditmodel_create {\n                width: 15%;\n                height: 40px;\n                background: #0C3688;\n                box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 14px;\n                color: #FFFFFF;\n                border: none;\n            }\n            \n            .AddEditmodel_create:disabled{\n                background: #5a77b0;\n            }\n        }\n    }\n\n    .add-modules-titles {\n        position: absolute;\n        top: 32%;\n        left: 80%;\n        font-size: 14px;\n    }\n\n}\n.module-form-select{\n    width: 13rem;\n    background-color: white;\n}\n.module-form-select fieldset {\n    border: 1px solid #a3aec4;\n    border-radius: 6px;\n  }\n.module-select{\n    height: 32px;\n    width: 100% !important;\n}\n.module_input{\n    min-width: 80%;\n}\n\n::-webkit-scrollbar {\n    width: 0.875em;\n}\n\n::-webkit-scrollbar-thumb {\n    background: rgba(163, 174, 196, 1);\n    border-radius: 0em;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(163, 174, 196, 1);\n}\n.content-titless {\n    position: absolute;\n    left: 82%;\n    z-index: 4;\n    top: 1.2rem;\n    font-size: 13px;\n}\n@media screen and (max-width:480px) {\n    .AddEditModule_container{\n        display: flex;\n        flex-direction: column;\n    }\n    .AddEditModulecontent{\n        width: 100% !important;\n        margin: auto;\n    }\n    .search-input{\n        width: 90px !important;\n    }\n \n    .EditModule_containers .hero-section .modulePanel_checkbox{\n        display: flex;\n        justify-content: space-around !important;\n    }\n\n    .EditModule_containers .hero-section .title-input{\n        display: flex;\n        flex-direction: column;\n        width: 70%;\n    }\n    .EditModule_containers .AddEditModule_panel .panel-all .AddEditModule_Close{\n        margin-left: 50% !important;\n        width: fit-content;\n    }\n    .EditModule_containers .hero-section .checkbox_contain{\n        flex-direction: column;\n        gap: 0rem;\n    }\n    .module-form-select{\n        width: 100% !important;\n    }\n    .EditModule_containers .hero-section .checkbox_contain.checkbox_contain{\n        gap: 1rem !important;\n    }\n}\n@media screen and (max-width:768px) {\n    .EditModule_containers .AddEditModule_container{\n        flex-direction: column;\n    }\n    .EditModule_containers .AddEditModulecontent{\n        width: 100% !important;\n        height: 50vh;\n    }\n    .AddEditmodel_create{\n        width: fit-content !important;\n    }\n    .EditModule_containers .hero-section .search-input{\n        width: 100% !important;\n    }\n    .EditModule_containers .hero-section .modulePanel_checkbox{\n        flex-wrap: wrap;\n    }\n    .EditModule_containers .hero-section .checkbox_contain{\n        justify-content: flex-start;\n    }\n    .add-modules-titles{\n        top: 50% !important;\n        font-size: 12px !important;\n    }\n    .content-titless{\n        top: 50% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
